module.exports = __webpack_public_path__ + "img/criminal_case_part_1_splash.56053c0a.jpg";